import angular from 'angular';
import uiRouter from 'angular-ui-router';

import membersMapComponent from './members-map.component';

let membersMapModule = angular.module('membersMap', [
  uiRouter,
])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $stateProvider
      .state('engineer.members.map', {
        url: '/map',
        template: '<members-map members="$resolve.members" class="members-map"></members-map>',
        resolve: {
          members: function(Member) {
            return Member.map().$promise.then(response => response.members);
          }
        },
      });
  })
  .component('membersMap', membersMapComponent);

export default membersMapModule;



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/members/screens/members-map/index.js